import loadBasketModule from './modules/Basket.module';
import loadCheckoutModule from './modules/Checkout.module';
import loadCookieConsentModule from './modules/CookieConsent.module';
import loadPromoBasketPopupModule from './modules/PromoBasketPopup.module';
import loadProductModule from './modules/Product.module';
import loadDeliveryPromiseModule from './modules/DeliveryPromise.module';
import loadProductGroupFredhopperModule from './modules/ProductGroupFredhopper.module';
import loadCustomerModule from './modules/Customer.module';
const loadBasketMenuItemModule = initialData => ({
    hasRouter: false,
    modules: [
        loadCookieConsentModule(),
        loadBasketModule(),
        loadCheckoutModule(),
        loadPromoBasketPopupModule(),
        loadProductModule(),
        loadDeliveryPromiseModule(),
        loadCustomerModule(),
        loadProductGroupFredhopperModule(initialData),
    ],
});
export default loadBasketMenuItemModule;
